const transportInitialState = {

    //quote details
    loadingTransportQuoteDetail: false,
    transportQuoteDetailDataError: "",
    transportQuoteDetailData: [],


    //quote details
    loadingTransportList: false,
    transportListDataError: "",
    transportListData: [],
    transportListCurrentPage: 0,
    transportListTotalData: 0,
    transportListPerPageData: 0,
    transportListTotalPages: 0,


    //quote details
    loadingTransporterWithoutList: false,
    transporterWithoutListDataError: "",
    transporterWithoutListData: [],


    //quote details
    loadingTransporterList: false,
    transporterListDataError: "",
    transporterListData: [],
    transporterListCurrentPage: 0,
    transporterListTotalData: 0,
    transporterListPerPageData: 0,
    transporterListTotalPages: 0,

    //quote details
    loadingTransporterDetail: false,
    transporterDetailDataError: "",
    transporterDetailData: [],


    loadingDriverList: false,
    DriverListError: "",
    DriverList: [],
    DriverListCurrentPage: 0,
    DriverListTotalData: 0,
    DriverListPerPageData: 0,
    DriverListTotalPages: 0,

    loadingVehicleList: false,
    VehicleListError: "",
    VehicleList: [],
    VehicleListCurrentPage: 0,
    VehicleListTotalData: 0,
    VehicleListPerPageData: 0,
    VehicleListTotalPages: 0,

    loadingVehicleActiveList: false,
    VehicleActiveListDataError: "",
    VehicleActiveListData: [],


    loadingDriverDetail: false,
    DriverDetailDataError: "",
    DriverDetailData: [],


    loadingVehicleDetail: false,
    VehicleDetailDataError: "",
    VehicleDetailData: [],


}

const TransportReducer = (state = transportInitialState, action) => {
    switch (action.type) {
        //product-type//
        case 'FIND_TRANSPORT_QUOTE_DETAIL_REQUEST':
            return {
                ...state,
                loadingTransportQuoteDetail: true,
                transportQuoteDetailData: "",
                transportQuoteDetailDataError: '',
            };
        case 'FIND_TRANSPORT_QUOTE_DETAIL_SUCCESS':
            return {
                ...state,
                loadingTransportQuoteDetail: false,
                transportQuoteDetailData: action.payload,
            };
        case 'FIND_TRANSPORT_QUOTE_DETAIL_FAILURE':
            return {
                ...state,
                loadingTransportQuoteDetail: false,
                transportQuoteDetailDataError: action.payload,
            };


        case 'FIND_TRANSPORT_QUOTE_LIST_REQUEST':
            return {
                ...state,
                loadingTransportList: true,
                transportListData: [],
                transportListDataError: '',
            };
        case 'FIND_TRANSPORT_QUOTE_LIST_SUCCESS':
            return {
                ...state,
                loadingTransportList: false,
                transportListData: action.payload?.data || [],
                transportListCurrentPage: action.payload?.pagination?.currentPage,
                transportListTotalData: action.payload?.pagination?.totalRecords,
                transportListPerPageData: action.payload?.pagination?.pageSize,
                transportListTotalPages: action.payload?.pagination?.totalPages,
            };
        case 'FIND_TRANSPORT_QUOTE_LIST_FAILURE':
            return {
                ...state,
                loadingTransportList: false,
                transportListDataError: action.payload,
            };


        case 'FIND_TRANSPORTER_LIST_REQUEST':
            return {
                ...state,
                loadingTransporterList: true,
                transporterListData: [],
                transporterListDataError: '',
            };
        case 'FIND_TRANSPORTER_LIST_SUCCESS':
            return {
                ...state,
                loadingTransporterList: false,
                transporterListData: action.payload?.data || [],
                transporterListCurrentPage: action.payload?.pagination?.currentPage,
                transporterListTotalData: action.payload?.pagination?.totalRecords,
                transporterListPerPageData: action.payload?.pagination?.pageSize,
                transporterListTotalPages: action.payload?.pagination?.totalPages,
            };
        case 'FIND_TRANSPORTER_LIST_FAILURE':
            return {
                ...state,
                loadingTransporterList: false,
                transporterListDataError: action.payload,
            };

        case 'FIND_TRANSPORTER_WITHOUT_LIST_REQUEST':
            return {
                ...state,
                loadingTransporterWithoutList: true,
                transporterWithoutListData: "",
                transporterWithoutListDataError: '',
            };
        case 'FIND_TRANSPORTER_WITHOUT_LIST_SUCCESS':
            return {
                ...state,
                loadingTransporterWithoutList: false,
                transporterWithoutListData: action.payload,
            };
        case 'FIND_TRANSPORTER_WITHOUT_LIST_FAILURE':
            return {
                ...state,
                loadingTransporterWithoutList: false,
                transporterWithoutListDataError: action.payload,
            };


        case 'FIND_TRANSPORTER_DETAIL_REQUEST':
            return {
                ...state,
                loadingTransporterDetail: true,
                transporterDetailData: "",
                transporterDetailDataError: '',
            };
        case 'FIND_TRANSPORTER_DETAIL_SUCCESS':
            return {
                ...state,
                loadingTransporterDetail: false,
                transporterDetailData: action.payload,
            };
        case 'FIND_TRANSPORTER_DETAIL_FAILURE':
            return {
                ...state,
                loadingTransporterDetail: false,
                transporterDetailDataError: action.payload,
            };

        //driver list List//
        case 'FIND_DRIVER_LIST_REQUEST':
            return {
                ...state,
                loadingDriverList: true,
                DriverList: [],
                DriverListDataError: '',
            };
        case 'FIND_DRIVER_LIST_SUCCESS':
            return {
                ...state,
                loadingDriverList: false,
                DriverList: action.payload?.data || [],
                DriverListCurrentPage: action.payload?.pagination?.currentPage || 1,
                DriverListTotalData: action.payload?.pagination?.totalRecords || 0,
                DriverListPerPageData: action.payload?.pagination?.pageSize || 10,
                DriverListTotalPages: action.payload?.pagination?.totalPages || 0,
            };
        case 'FIND_DRIVER_LIST_FAILURE':
            return {
                ...state,
                loadingDriverList: false,
                DriverListDataError: action.payload,
            };
        //driver List//


        case 'FIND_DRIVER_DETAIL_REQUEST':
            return {
                ...state,
                loadingDriverDetail: true,
                DriverDetailData: "",
                DriverDetailDataError: '',
            };
        case 'FIND_DRIVER_DETAIL_SUCCESS':
            return {
                ...state,
                loadingDriverDetail: false,
                DriverDetailData: action.payload,
            };
        case 'FIND_DRIVER_DETAIL_FAILURE':
            return {
                ...state,
                loadingDriverDetail: false,
                DriverDetailDataError: action.payload,
            };


        //vehicle list List//
        case 'FIND_VEHICLE_LIST_REQUEST':
            return {
                ...state,
                loadingVehicleList: true,
                VehicleList: [],
                VehicleListError: '',
            };
        case 'FIND_VEHICLE_LIST_SUCCESS':
            return {
                ...state,
                loadingVehicleList: false,
                VehicleList: action.payload?.data || [],
                VehicleListCurrentPage: action.payload?.pagination?.currentPage || 1,
                VehicleListTotalData: action.payload?.pagination?.totalRecords || 0,
                VehicleListPerPageData: action.payload?.pagination?.pageSize || 10,
                VehicleListTotalPages: action.payload?.pagination?.totalPages || 0,
            };
        case 'FIND_VEHICLE_LIST_FAILURE':
            return {
                ...state,
                loadingVehicleList: false,
                VehicleListError: action.payload,
            };
        //vehicle List//


        case 'FIND_VEHICLE_DETAIL_REQUEST':
            return {
                ...state,
                loadingVehicleDetail: true,
                VehicleDetailData: "",
                VehicleDetailDataError: '',
            };
        case 'FIND_VEHICLE_DETAIL_SUCCESS':
            return {
                ...state,
                loadingVehicleDetail: false,
                VehicleDetailData: action.payload,
            };
        case 'FIND_VEHICLE_DETAIL_FAILURE':
            return {
                ...state,
                loadingVehicleDetail: false,
                VehicleDetailDataError: action.payload,
            };


        case 'FIND_VEHICLE_WITHOUT_LIST_REQUEST':
            return {
                ...state,
                loadingVehicleActiveList: true,
                VehicleActiveListData: [],
                VehicleActiveListDataError: '',
            };
        case 'FIND_VEHICLE_WITHOUT_LIST_SUCCESS':
            return {
                ...state,
                loadingVehicleActiveList: false,
                VehicleActiveListData: action.payload,
            };
        case 'FIND_VEHICLE_WITHOUT_LIST_FAILURE':
            return {
                ...state,
                loadingVehicleActiveList: false,
                VehicleActiveListDataError: action.payload,
            };


        default:
            return state;
    }
}

export default TransportReducer;